<template>
    <section class="sectionBackGround">

        <div class="container pt-lg-md">
            <div class="row justify-content-center" style="margin-top: 10%;">
                <div class="col-lg-5">
                    <div>
                        <template>
                            <div class="text-center" style="
                                    color: white;
                                    font-family: ‘Noto Sans S Chinese’;
                                    font-size: 40px;
                                    font-style: normal;
                                    font-weight: 800;
                                    line-height: 58px;
                                    letter-spacing: 1px;">
                                AnthroMindXX
                            </div>
                            <div class="text-center mb-4" style="
                                    color: white;
                                    font-family: ‘Noto Sans S Chinese’;">
                                这里是一个关于健康饮食的个人网站<br />
                                用户付费后登录使用<br />
                                更多信息可以在 AntroMindXX 微博主页了解
                            </div>
                        </template>
                        <template>
                            <form role="form">
                                <base-input style="
                                border-radius: 6px;
                                background: rgba(255, 255, 255, 0.40);" v-model="username" placeholder="用户名（至少5个字母）"
                                    addon-left-icon="ni ni-hat-3">
                                </base-input>
                                <base-input style="border-radius: 6px;
                                    background: rgba(255, 255, 255, 0.40);" v-model="email" placeholder="邮箱地址"
                                    addon-left-icon="ni ni-email-83">
                                </base-input>
                                <base-input style="border-radius: 6px;
                                            background: rgba(255, 255, 255, 0.40);" type="password" v-model="password"
                                    placeholder="密码（至少6个字母" addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <base-input style="border-radius: 6px;
                                            background: rgba(255, 255, 255, 0.40);" v-model="confirmPassword"
                                    type="password" placeholder="确认密码" addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <!-- 显示密码不一致的提示 -->
                                <div v-if="passwordMismatch" class="text-danger">
                                    密码不一致，请重新输入
                                </div>
                                <div class="text-center">
                                    <base-button type="primary"
                                        style="border-radius: 8px; background: rgba(15, 245, 200, 0.90);" size="lg"
                                        block class="my-4"
                                        :disabled="!username || !email || !password || !confirmPassword || passwordMismatch"
                                        @click.prevent="register">
                                        注 册
                                    </base-button>
                                </div>
                            </form>

                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            username: '',
            email: '',
            password: '',
            confirmPassword: '',  // 添加确认密码字段
            passwordMismatch: false  // 用于检测密码是否匹配
        };
    },
    methods: {
        // 校验邮箱格式
        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },

        async register() {
            // 校验密码是否一致
            if (this.password !== this.confirmPassword) {
                alert("密码不一致，请重新输入！");
                return;
            }

            // 校验邮箱格式是否正确
            if (!this.validateEmail(this.email)) {
                alert("邮箱格式不正确！");
                return;
            }

            // 继续注册流程
            try {
                const params = new URLSearchParams();
                params.append('username', this.username);
                params.append('email', this.email);
                params.append('password', this.password);

                const response = await axios.post('https://anthromindxx.com/ca.php?action=register', params);

                if (response.data.success) {
                    const token = response.data.token;
                    localStorage.setItem('token', token);  // 保存 token 到 localStorage
                    this.$router.push('/AboutUs');  // 注册成功后跳转页面
                } else {
                    // 显示后端返回的错误信息
                    alert(response.data.message || '注册失败');
                }
            } catch (error) {
                console.error('注册失败:', error.response.data);
            }
        }
    }, watch: {
        password() {
            this.passwordMismatch = this.password !== this.confirmPassword;
        },
        confirmPassword() {
            this.passwordMismatch = this.password !== this.confirmPassword;
        }
    }
}
</script>
<style scoped>
.sectionBackGround {
    /* 使内容区域填充剩余空间 */
    min-height: calc(100vh - 48px);
    /* 确保内容区域至少与视口高度减去头部高度一样大 */
    background-image: url('https://anthromindxx.com/ant/zhuce.png');
    /* 设置背景图路径 */
    background-position: center center;
    /* 背景图片位置 */
    background-attachment: fixed;
    /* 背景图片相对于视口固定 */
    background-size: 100% 100%;
    /* 背景图片根据元素大小缩放 */
    overflow-y: auto;
    /* 在内容较多时显示滚动条 */
}
</style>
